<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div class="vx-row">
      <vx-card>
        <vs-table
          class="ticketsearch"
          :max-items="descriptionItems[0]"
          pagination
          :data="reportList"
          description
          search
          @selected="handleSelected"
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              <h2>
                {{ $t("reports.label.reports") }}
              </h2>
            </div>
            <!-- <div class="order-1">
              <v-select
                label="value"
                :options="filterOption"
                placeholder="--Select One--"
                v-model="categoryFilter"
                @input="filterReports"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                class="min-w-200 w-full mb-2"
              >
              </v-select>
            </div> -->
          </template>
          <template slot="thead">
            <vs-th>{{ $t("reports.label.name") }}</vs-th>
            <vs-th>{{ $t("reports.label.type") }}</vs-th>
            <vs-th>{{ $t("reports.label.category") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :key="index"
              :data="clientsLists"
              v-for="(clientsLists, index) in data"
            >
              <vs-td :data="clientsLists.report_name">{{
                clientsLists.report_name
              }}</vs-td>
              <vs-td :data="clientsLists.report_type">{{
                clientsLists.report_type
              }}</vs-td>
              <vs-td :data="clientsLists.report_category">{{
                clientsLists.report_category
              }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";
import vSelect from "vue-select";
export default {
  data() {
    return {
      loading: false,
      reportList: [],
      filterOption: [],
      categoryFilter: "",
      searchOption: 0,
      originalReportList: null,
      descriptionItems: [10, 20, 30],
      output: [
        "Reports",
        "Clients",
        "Orders",
        "Tickets",
        "Inventory",
        "Leads",
        "BroadCaster",
        "AccessProfile",
        "Invoice&Collections",
        "Organization",
      ],
    };
  },
  components: { "v-select": vSelect, AtomSpinner },
  computed: {
    ...mapState({
      clientsList: (state) => state.reports.clientsList,
    }),
  },
  methods: {
    handleSelected(clientsLists) {
      this.$router.push({
        path: `/listViewReports/${clientsLists.report_name}`,
      });
    },
    filterReports() {
      if (this.categoryFilter) {
        const filter = this.categoryFilter.toLowerCase();
        this.reportList = this.originalReportList.filter(
          (item) => item.report_category.toLowerCase() === filter
        );
      } else {
        this.reportList = [...this.originalReportList];
      }
    },
    async getAllReportLists() {
      this.loading = true;
      try {
        await this.$store.dispatch("reports/setAllReport");
        const reportMap = this.clientsList.reduce((map, item) => {
          if (!map[item.report_id]) {
            map[item.report_id] = {
              report_name: item.report_name,
              report_type: item.report_type,
              report_category: item.report_category,
              parameters: [],
            };
          }
          map[item.report_id].parameters.push({
            report_parameter_name: item.report_parameter_name,
            parameter_name: item.parameter_name,
          });
          return map;
        }, {});
        this.originalReportList = Object.values(reportMap);
        this.reportList = [...this.originalReportList];
        this.filterOption = [
          ...new Set(
            this.originalReportList.map((item) => item.report_category.toUpperCase())
          ),
        ];
        this.filterReports();
      } catch (e) {
        console.error("An error occurred while fetching reports:", e);
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    categoryFilter(newVal) {
      this.filterReports();
    },
  },
  mounted() {
    this.getAllReportLists();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
.no-header .vs-popup .vs-popup--content {
  overflow: visible;
}

.min-w-100 {
  min-width: 10rem;
}
.ticketsearch ::v-deep .con-input-search.vs-table--search {
  position: relative;
}
</style>
